module.exports = __webpack_public_path__ + "static/media/combo-images-dots.2b6d1501.png";